import { i18n } from "@tellescope/i18n";

export const getMedStatusTranslations: () => Record<string, string> = () => ({
  "Medication: Unknown": i18n.t("Unknown", { ns: "vitals" }),
  "Medication: Before Meds": i18n.t("Before Meds", { ns: "vitals" }),
  "Medication: After Meds": i18n.t("After Meds", { ns: "vitals" }),
});

export const getObservationFlags = <
  T extends { beforeMeal?: boolean; irregularHeartbeat?: boolean; medStatus?: string },
>({
  beforeMeal,
  medStatus,
  irregularHeartbeat,
}: T): string[] => {
  const result: string[] = [];
  if (beforeMeal !== undefined) {
    result.push(beforeMeal ? i18n.t("Before Meal", { ns: "vitals" }) : i18n.t("After Meal", { ns: "vitals" }));
  }

  if (medStatus !== undefined) {
    result.push(getMedStatusTranslations()[medStatus] ?? medStatus.replace("Medication: ", ""));
  }

  if (irregularHeartbeat !== undefined) {
    result.push(irregularHeartbeat ? i18n.t("Irregular", { ns: "vitals" }) : i18n.t("Regular", { ns: "vitals" }));
  }

  return result;
};
